var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEscKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 9,
    viewBox: "0 0 22 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.20734 8.5V7.612H1.95934V4.852H6.12334V3.964H1.95934V1.384H6.20734V0.495999H0.963344V8.5H6.20734ZM10.3874 8.644C12.5474 8.644 13.3394 7.444 13.3394 6.292C13.3394 3.304 8.59938 4.336 8.59938 2.536C8.59938 1.78 9.29538 1.264 10.2434 1.264C11.1194 1.264 11.9594 1.552 12.5594 2.224L13.1594 1.492C12.4874 0.784 11.5394 0.364 10.3274 0.364C8.74338 0.364 7.56738 1.276 7.56738 2.596C7.56738 5.452 12.3074 4.3 12.3074 6.364C12.3074 6.988 11.8514 7.756 10.4234 7.756C9.29538 7.756 8.43138 7.204 7.91538 6.604L7.31538 7.372C7.97538 8.116 9.00738 8.644 10.3874 8.644ZM18.6186 8.644C20.0346 8.644 20.9946 7.972 21.6666 7.048L20.8266 6.592C20.3706 7.264 19.5306 7.756 18.6186 7.756C16.8666 7.756 15.5346 6.4 15.5346 4.504C15.5346 2.584 16.8666 1.252 18.6186 1.252C19.5306 1.252 20.3706 1.732 20.8266 2.416L21.6546 1.948C21.0186 1.036 20.0346 0.364 18.6186 0.364C16.3146 0.364 14.5026 2.044 14.5026 4.504C14.5026 6.964 16.3146 8.644 18.6186 8.644Z",
    fill: "#A8ACAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEscKey);
export default __webpack_public_path__ + "static/media/icon-esc-key.80f1c6aae5e7608285d57346c635051b.svg";
export { ForwardRef as ReactComponent };